<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          <CCol sm="12" lg="12" >       
            <div class="content-wrapper">
              <div id="app">
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' locale='zh-TW' :dataSource='datas' height='500' :allowExcelExport='true'
                    :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true' 
                    :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :rowDataBound="onRowDataBound"
                    :toolbarClick="toolbarClick"  :editSettings='editSettings' @rowSelected="onRowSelected" >                             
                    <e-columns>        
                        <e-column field='is_import' headerText='重要' width='80' :template='importTemplate'></e-column>  
                        <e-column field='is_reader' headerText='已讀' width='80' :template='readTemplate'></e-column>          
                        <e-column field='title' headerText='主旨' width='50'></e-column>   
                        <e-column field='begin_date' headerText='發布時間' width='120' ></e-column>   
                        <e-column field='end_date' headerText='結束時間' width='120'  ></e-column>   
                        <e-column field='send' headerText='發布人員' width='160'></e-column> 
                    </e-columns>
                    
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
        </CRow>
      </CCardBody>   
    </CCard>
  </template>
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script lang="ts">
  
  import Vue from "vue";
  import { L10n, enableRipple  } from '@syncfusion/ej2-base';
  import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
  import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
  import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
  import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
  import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
  import zhtwLocalization  from '../language/language.json';
  
  L10n.load(zhtwLocalization);
  
  enableRipple(true);
  Vue.use(DialogPlugin);
  Vue.use(GridPlugin);    
  Vue.use(ButtonPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(NumericTextBoxPlugin );
  Vue.use(RadioButtonPlugin);
  Vue.use(TooltipPlugin);
  
  export default {
  name: 'GetMaterials',
  components: {
    // 'ejs-button': ButtonComponent,
  },
  data: function() {
    return {
        datas : [],
        selectedRowData:null,
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal' },
        pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },     
        toolbar: [
          { text: '檢視', tooltipText: '檢視', prefixIcon: 'e-btn-icon e-search e-icons e-icon-left', id: 'Add' },    
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   

        filterSettings: { type: 'CheckBox' },     
        visible : false,
        freightrules:  { required: true, min: 0, number: true},
        importTemplate: function() {
          return {
            template: Vue.component('importTemplate', {
                
                template: `
                  <div>
                      <span v-if="importStatus == true" style="color: red; font-weight: bold;">❗</span>
                      <span else style="color: red; font-weight: bold; "></span>
                  </div>`,
                 data: function () { return { data: {}, inactive: 'Inactive' }; },
                 computed: {
                importStatus() {
                // 安全地從 props 拿值
                return this.data && typeof this.data.is_import !== 'undefined'
                  ? this.data.is_import
                  : false;
                  }
              }
              })}},
           readTemplate: function() {
          return {
            template: Vue.component('importTemplate', {
                
                template: `
                  <div>
                      <span v-if="importStatus == true" style=" font-weight: bold;">已讀</span>
                      <span v-else style="color: red; font-weight: bold;">未讀</span>
                  </div>`,
                 data: function () { return { data: {}, inactive: 'Inactive' }; },
                 computed: {
                importStatus() {
                // 安全地從 props 拿值
                return this.data && typeof this.data.is_reader !== 'undefined'
                  ? this.data.is_reader
                  : false;
                  }
              }
              })}},
      };
  },
  methods: {    
   onRowDataBound:function(args) {
      // forecast_use, actual_use , finish_use
      // 領完為灰色 FCFCFC 
      if (args.data.is_reader) {
        args.row.style.backgroundColor = '#FFFFFF'; // 白色            
      } else {
        args.row.style.backgroundColor = '#FFECF5'; // 粉色
      }
    },
    onload:function() {
      // 初始化
    },
    submit:function() {
      this.$emit('onGetMaterialsClose');
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
          this.$refs.tooltip.content = args.target.innerText;                
      }
    },   
    pubDoubleClick: function () {  
          this.$refs.modalDialog.show();
      },
      editOkClick: function () {           
          this.upData();         
      },
      valueChange: function () {  
          this.isDataChanged = true;
          this.stTime = null;
      },
      load: function() {   
  
      },       
      addAction: function() {
  
      },      
      toolbarClick: function(args) {
        if (args.item.id == "Export") {
          this.$refs.grid.excelExport({ fileName:'訊息清單.xlsx' });
        }
        if (args.item.id == "Add") { 
        
          return this.$router.push(`/system/mymessage?msgID=${this.selectedRowData.msgID}`)     
        }
        if (args.item.id == "Edit") {
          this.$refs.grid.excelExport();
        }
      },   
         onRowSelected(args) {
    this.selectedRowData = args.data;
    console.log(args.data)
    // 你可以拿來做編輯、跳轉、顯示詳情等用途
  },
        //api
        getMsg: function () {  
          this.axios({
              method: 'get',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Message/My/Content`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.showMsg(response.data.msg) ;return; }                 
            this.datas = response.data.datas;
            console.log(response.data.datas)
            return; 
          })
          .catch((error) => { 
            this.showMsg(error) 
          })             
        },
        
      showError: function(error) {
          if (error.response.status == 400) {
              for(var key in error.response.data.errors){                 
                  this.$toast.open({message: error.response.data.errors[key][0] , type: "warning", duration: 5000, dismissible: true}) 
              }
              return;
          }    
          if (error.response.status == 401) {  
              localStorage.removeItem('token'); this.$router.push('/login'); 
              return; 
          }                
          this.$toast.open({message: '系統發生錯誤' + error.response.status, type: "error", duration: 5000, dismissible: true}) 
      }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
  },
  created() {
    this.getMsg();

  },
  mounted() {
    
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
   
  }  
  }
  </script>